module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon14.622bb99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon14.png
// module id = B7Ow
// module chunks = 0